import React, { useState } from "react";
import { useTreeWriteContext } from "./TreeContext";
import { Box, IconButton, TextField, Typography } from "@mui/material";
import RenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import BuildIcon from "@mui/icons-material/Build";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { RemoveGamePieceButton } from "./RemoveGamePieceButton";

interface GamePieceHeaderProps {
  gamePieceName: string;
  isCollapsed: boolean;
  setIsCollapsed: (value: ((prevState: boolean) => boolean) | boolean) => void;
  setIsRaw: (value: ((prevState: boolean) => boolean) | boolean) => void;
  isRaw: boolean;
  isAlwaysRaw: boolean;
}

function RenameGamePiece(props: { onClick: () => void; gamePieceName: string }) {
  if (
    props.gamePieceName === "root" ||
    props.gamePieceName === "dims" ||
    props.gamePieceName.startsWith("__card") ||
    props.gamePieceName.startsWith("deck-")
  ) {
    return <></>;
  }
  return (
    <IconButton color="primary" aria-label="rename" onClick={props.onClick}>
      <RenameOutlineIcon />
    </IconButton>
  );
}

export function GamePieceHeader(props: GamePieceHeaderProps) {
  const [newGamePieceName, setNewGamePieceName] = useState("");
  const [renamingGamePiece, setRenamingGamePiece] = useState(false);

  const { onTryRenameGamePiece } = useTreeWriteContext();

  return (
    <Box className="horizontal-flex game-piece-header">
      {!renamingGamePiece && (
        <>
          <Typography className="game-piece-header-name" variant="h5">
            {props.gamePieceName}
          </Typography>
          <RenameGamePiece
            gamePieceName={props.gamePieceName}
            onClick={() => {
              setRenamingGamePiece(true);
              setNewGamePieceName(props.gamePieceName);
            }}
          />
        </>
      )}

      {renamingGamePiece && (
        <>
          <TextField
            id="new-position-set-name"
            label="New position set name"
            autoFocus={true}
            variant="outlined"
            value={newGamePieceName}
            onChange={(event) => setNewGamePieceName(event.target.value)}
          />
          <IconButton
            color="primary"
            aria-label="confirm"
            onClick={() => {
              onTryRenameGamePiece(props.gamePieceName, newGamePieceName);
              setRenamingGamePiece(false);
              setNewGamePieceName("");
            }}
          >
            <CheckIcon />
          </IconButton>
          <IconButton color="error" aria-label="close" onClick={() => setRenamingGamePiece(false)}>
            <CloseIcon />
          </IconButton>
        </>
      )}
      <Box className="flex-filler"></Box>
      <RemoveGamePieceButton />
      {!props.isAlwaysRaw && (
        <IconButton color="secondary" aria-label="raw" onClick={() => props.setIsRaw(!props.isRaw)}>
          <BuildIcon />
        </IconButton>
      )}
      <IconButton color="primary" aria-label="collapse" onClick={() => props.setIsCollapsed(!props.isCollapsed)}>
        {props.isCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
      </IconButton>
    </Box>
  );
}
